import { getDynamicBadgeQty, getAPIConfig } from '@tcp/core/src/utils';
import {
  flatCurrencyToCents,
  getPdpUrl,
  imageGenerator,
  sanitizeEntity,
} from '@tcp/core/src/services/abstractors/SFCC/CartItemTile';
import isEmpty from 'lodash/isEmpty';

export const prepareInventoryCartData = ({ productList = [] }, cart = []) => {
  const inventoryCartData = [];
  for (let i = 0; i < cart.length; i += 1) {
    const invObj = {};
    for (let j = 0; j < productList.length; j += 1) {
      if (productList[j].productId === cart[i]?.productInfo?.productId) {
        Object.assign(invObj, productList[i], cart[i]);
      }
    }
    inventoryCartData.push(invObj);
  }

  return inventoryCartData;
};

export const prepareOrderItems = (productItems = []) => {
  let totalItems = 0;
  const orderItems = [];
  let totalPrice = 0;
  productItems.forEach((productItem) => {
    const product = JSON.parse(JSON.stringify(productItem));
    product.itemPoints = null;
    totalItems += parseInt(product?.quantity, 10);
    totalPrice += product?.price;
    const itemUnitPrice = +`${Math.round(`${product?.price / product?.quantity}e+2`)}e-2`;
    const createdProduct = {
      productInfo: {
        generalProductId: product?.productId,
        productPartNumber: product?.c_prodPartNo,
        skuId: product?.productId,
        name: sanitizeEntity(product?.productName),
        imagePath: imageGenerator(product?.c_prodPartNo).productImages[500],
        upc: product?.productId,
        pdpUrl: getPdpUrl(product?.c_TCPimages, product?.c_prodPartNo),
        color: {
          name: product?.c_TCPColor ? product?.c_TCPColor : product?.productName,
        },
        seoToken: product?.c_seoToken,
        productId: product?.productId,
        tcpStyleQty: product?.c_TCPStyleQTY || '',
        tcpStyleType: product?.c_TCPStyleType || '',
        itemBrand: product?.c_brand || 'TCP',
        isBundleProduct: !isEmpty(product?.bundledProductItems),
      },
      itemInfo: {
        quantity: parseInt(product?.quantity, 10),
        itemId: product?.itemId.toString(),
        itemPoints: product?.itemPoints || 0,
        listPrice: flatCurrencyToCents(product?.priceAfterOrderDiscount),
        offerPrice: flatCurrencyToCents(product?.priceAfterOrderDiscount),
        wasPrice: flatCurrencyToCents(product?.c_list_price),
        itemUnitDstPrice: product?.priceAfterOrderDiscount,
        itemUnitPrice: product?.basePrice,
        price: product?.price,
        // eslint-disable-next-line no-nested-ternary
        salePrice: flatCurrencyToCents(itemUnitPrice),
        preOrderDate: product?.preOrderDate,
        bundledProductItems: product?.bundledProductItems,
        taxClassId: product?.taxClassId,
        isGiftItem: product?.gift,
      },
    };
    orderItems.push(createdProduct);
  });
  return { totalItems, orderItems, totalPrice };
};

export const getItemBrand = (itemBrand) => itemBrand && itemBrand?.toUpperCase();
export const getDynamicBadgeOverlayQty = (tcpStyleType, tcpStyleQty, isDynamicBadgeEnabled) =>
  getDynamicBadgeQty(tcpStyleType, tcpStyleQty, isDynamicBadgeEnabled);

export const getProductListToPath = (str) => {
  if (str && str.indexOf('/b/') !== -1) {
    return `/b?bid=${str?.split('/b/')[1]}`;
  }
  if (str && str?.split('/p/') !== -1) {
    return `/p?pid=${str?.split('/p/')[1]}`;
  }
  return str;
};

export const getSeoUrl = (seotoken) => {
  const { siteId } = getAPIConfig();
  return `/${siteId}/p/${seotoken}`;
};
export const getPdpToPath = (
  isProductBrandOfSameDomain,
  pdpUrl,
  crossDomain,
  brandSpecificCrossDomain,
  brand,
  isCrossBrandMerchandisingEnabled,
  seoToken
) => {
  let pdpLinkPath = pdpUrl;
  if (seoToken) {
    pdpLinkPath = getSeoUrl(seoToken);
  }

  if (isProductBrandOfSameDomain) return getProductListToPath(pdpLinkPath);
  if (isCrossBrandMerchandisingEnabled)
    return `${getProductListToPath(pdpLinkPath)}$brand=${brand?.toUpperCase()}`;
  return `${brandSpecificCrossDomain[brand?.toUpperCase()]}${pdpLinkPath}`;
};

export const getTotalPointsEarned = (items = []) => {
  return items.reduce((a, b) => {
    const {
      itemInfo: { itemPoints },
    } = b;
    return a + itemPoints;
  }, 0);
};

export const getPdpAsPath = ({ seoToken, siteId, productPartNo, isBundleProduct }) => {
  return isBundleProduct
    ? {
        pdpUrl: {
          asPath: `/${siteId}/b/${seoToken || productPartNo}`,
          asPathWithoutSlug: `/b/${seoToken || productPartNo}`,
          href: `/b?bid=${seoToken || productPartNo}&referer=categoryPage&dataSource=newplp`,
        },
      }
    : {
        pdpUrl: {
          asPath: `/${siteId}/p/${seoToken || productPartNo}`,
          asPathWithoutSlug: `/p/${seoToken || productPartNo}`,
          href: `/p?pid=${seoToken || productPartNo}&referer=categoryPage&dataSource=newplp`,
        },
      };
};
